import KeepUI from '@/lib/keep-ui'
import {Boot} from '@/project'

const boot: Boot = ({Vue}) => {
  Vue.use(KeepUI)
}

export default boot
